interface Fade { readonly endValues: { alpha?: number }; kill(): void }
interface LayerSurface { alpha: number; visible: boolean }

/** Retarget stair fades without an opacity jump or an obsolete completion callback. */
export function prepareLayerFade(surface: LayerSurface, previous: Fade | undefined, visible: boolean, initial: boolean): boolean {
    const target = visible ? 1 : 0;
    if (!initial && (previous ? previous.endValues.alpha === target : surface.visible === visible)) return false;
    previous?.kill();
    if (initial) {
        surface.visible = visible;
        surface.alpha = target;
    } else if (!surface.visible) {
        surface.alpha = 0;
    }
    return true;
}
